import React from 'react';
import { RenovadoresBonusCardC1 } from './renovadores-bonus-card-c1';
import { RenovadoresBonusCardC2 } from './renovadores-bonus-card-c2';
import { RenovadoresBonusCardC3 } from './renovadores-bonus-card-c3';
import { HuchaValues } from '../../../models/hucha-values';
import { RenovadoresHuchaCardContainer } from '../../ui/hucha-card-container';

const RenovadoresBonusCard: React.FC<{
	huchaValues: HuchaValues | null;
}> = ({ huchaValues }): React.ReactElement => {
	return (
		<RenovadoresHuchaCardContainer>
			<RenovadoresBonusCardC1 huchaValues={huchaValues} />
			<RenovadoresBonusCardC2 dineroHucha={huchaValues?.dineroHucha || '0'} />
			<RenovadoresBonusCardC3 huchaValues={huchaValues} />
		</RenovadoresHuchaCardContainer>
	);
};

export default RenovadoresBonusCard;
